import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import axios from "axios";
import {
  FaFolder,
  FaArrowLeft,
  FaHome,
  FaListUl,
  FaTimes,
  FaCopy,
  FaCalendarAlt,
  FaCheck,
} from "react-icons/fa";
import { IoMdShareAlt } from "react-icons/io";
import { MdDownload } from "react-icons/md";
import { IoGridOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import awsService from "../services/awsService";
import Select from "react-select";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import shareService from "../services/shareService";
import { useStateContext } from "../contexts/ContextProvider";
import "react-datepicker/dist/react-datepicker.css";
import { CiFileOn } from "react-icons/ci";
import { Tooltip } from "react-tooltip";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

import { FaRegFileImage } from "react-icons/fa6";
import tenantService from "../services/tenantService";

import { FaUsers } from "react-icons/fa";
import { GrStorage } from "react-icons/gr";
import { AiFillFileZip } from "react-icons/ai";
import Loading from "../components/Loading";
import { toast, ToastContainer } from "react-toastify";
import SharedLinks from "../components/SharedLinks";
import { subDays } from "date-fns";

const HtmlPackage = () => {
  const [loading, setLoading] = useState(false);
  const [uploading, setupLoading] = useState(false);

  const { currentColor, currentMode } = useStateContext();
  const [files, setFiles] = useState([]);
  const [currentPrefix, setCurrentPrefix] = useState("");
  const [viewType, setViewType] = useState("grid");
  const location = useLocation();
  const [awsId, setAwsId] = useState([]);
  const [userId, setuserId] = useState("");
  const [bucketName, setBucketName] = useState([]);
  const [writeAccess, setWriteAccess] = useState(false);
  const [createFolder, setCreateFolder] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareEmails, setShareEmails] = useState([]);
  const [expiryDate, setExpiryDate] = useState(new Date());
  const [itemToShare, setItemToShare] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [createModal, setShowCreateModal] = useState(false);
  const [showShareLinkModal, setShowShareLinkModal] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const [sharePassword, setSharePassword] = useState("");
  const [showSharebutton, setshowSharebutton] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [buckets, setBuckets] = useState([]);
  const [showTenant, setshowTenant] = useState(true);
  const [showBucket, setshowBucket] = useState(false);
  const [showFiles, setshowFiles] = useState(false);
  const [currentView, setCurrentView] = useState("tenant");
  const [selectedTenant, SetSelectedTenant] = useState({});
  const [selectedBucket, setSelectedBucket] = useState({});
  const [folderName, setFolderName] = useState("");
  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [sharedLink, setSharedLink] = useState([]);
  const dropdownRef = useRef(null);
  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedPassword, setCopiedPassword] = useState(false);
  const [renameModal, setShowRenameModal] = useState(false);
  useEffect(() => {
    // Function to handle clicks outside of the dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownIndex(null); // Close the dropdown
      }
    };

    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event li
    // tener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setDropdownIndex]);
  const options = [
    { value: "viewOnlyAccess", label: "View Only" },
    { value: "downloadAccess", label: "Download" },
    { value: "uploadAccess", label: "Upload" },
    // {value:"withoutPassword",label:"No password"}
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #d1d5db", // Tailwind's gray-300
      borderRadius: "0.375rem", // Tailwind's rounded-lg
      padding: "0.2rem", // Tailwind's p-2
    }),
    multiValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
  };

  const toggleDropdown = (index) => {
    if (dropdownIndex === index) {
      setDropdownIndex(null); // Close dropdown if it's already open
    } else {
      setDropdownIndex(index); // Open the clicked dropdown
    }
  };

  const handleRenameFolder = async () => {
    handleCreateFolder();
  };

  const fetchData = async (prefix, bucketName, awsIdTenant) => {
    try {
      console.log("fetchdata--------", prefix, "----------", bucketName);
      setLoading(true);

      // if (
      //   !bucketName ||
      //   !bucketName.folders ||
      //   !bucketName.folders.folderName
      // ) {
      //   console.error(
      //     "bucketName or its properties are undefined:",
      //     bucketName
      //   );
      //   setLoading(false);
      //   return;
      // }

      // const allowedFolders = bucketName.folders.folderName;
      // console.log("ALLOW", allowedFolders);

      let data = {
        awsId: awsId.length > 0 ? awsId : awsIdTenant,
        bucketName: bucketName.bucketName,
        prefix,
      };
      console.log("Fetching data with:", data);
      const response = await awsService.gethtmlpackagelist(data);
      console.log("Response received:", response);

      if (prefix === "") {
        setshowSharebutton(false);
        let filteredFolders = response
          // .filter((o) => allowedFolders.includes(o.Prefix))
          .map((o) => {
            if (o.Type !== "folder") {
              o["newName"] = o.Key.substring(o.Key.lastIndexOf("-") + 1);
            } else {
              o["newName"] = o.Prefix.split("/")
                .filter((part) => part !== "")
                .pop();
            }
            return o;
          });

        const sortedData = filteredFolders.sort((a, b) => {
          if (a.Type === "folder" && b.Type !== "folder") {
            return -1;
          }
          if (a.Type !== "folder" && b.Type === "folder") {
            return 1;
          }
          return 0;
        });
        console.log(sortedData);

        setFiles(sortedData);
        setWriteAccess(false);
        setCurrentPrefix(prefix);
        setLoading(false);
        return sortedData;
      } else {
        const parts = prefix.split("/");
        console.log(parts, "-----", parts.length);
        if (parts.length > 1) {
          setshowSharebutton(true);
        } else {
          setshowSharebutton(false);
        }

        const sortedData = response.sort((a, b) => {
          if (a.Type === "folder" && b.Type !== "folder") {
            return -1;
          }
          if (a.Type !== "folder" && b.Type === "folder") {
            return 1;
          }
          return 0;
        });
        console.log(sortedData);
        let newData = sortedData.map((o) => {
          if (o.Type !== "folder") {
            o["newName"] = o.Key.substring(o.Key.lastIndexOf("-") + 1);
          } else {
            o["newName"] = o.Prefix.split("/")
              .filter((part) => part !== "")
              .pop();
          }
          return o;
        });
        console.log(newData);

        setFiles(newData);
        // if (prefix == "htmlpackages/") {
        // if (prefix == "htmlpackages/") {
        //   setWriteAccess(false);
        //   setCreateFolder(true);
        // } else {
        setWriteAccess(true);
        setCreateFolder(false);
        // }
        setCurrentPrefix(prefix);
        setLoading(false);
        return newData;
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetcTenant = async () => {
    const userDetails = localStorage.getItem("userData");
    const userid = JSON.parse(userDetails)?._id;
    setuserId(userid);
    let tenants = await tenantService.gettenantsbyuser({ user: userid });
    console.log(tenants);
    setTenants(tenants);
  };
  useEffect(() => {
    fetcTenant();
  }, []);

  const handleFolderClick = (folderKey, pf) => {
    console.log(folderKey, "first", pf);
    // setPreviousPrefix(pf);
    fetchData(folderKey, pf);
    // setCurrentView("file");
  };

  const handleFileClick = (fileKey) => {
    console.log("first");
    // Handle downloading file
  };

  const toggleGridView = () => {
    console.log("first");
    setViewType("grid");
  };

  const toggleListView = () => {
    setViewType("list");
  };

  const handleHomeClick = () => {
    setDropdownIndex(null);
    setCreateFolder(false);
    setshowTenant(true);
    setshowBucket(false);
    setshowFiles(false);
    setCurrentView("tenant");
    setFiles([]);
    setCurrentPrefix("");
    setSelectedBucket(null);
    setWriteAccess(false);
  };

  const handleCreateFolder = async () => {
    const userDetails = localStorage.getItem("userData");
    const userId = JSON.parse(userDetails)._id;
    // const folderName = prompt("Enter folder name:");
    setLoading(true);
    if (folderName) {
      const under_folder_name = replaceSpacesWithUnderscores(folderName);
      const newFolderKey = currentPrefix + under_folder_name + "/";
      try {
        let data = {
          folderKey: newFolderKey,
          bucketName: selectedBucket.bucketName,
          awsId: awsId,
          userId: userId,
          Htmlfolder: true,
        };
        console.log(data, "folder-data----");
        const create_folder = await awsService.createFolder(data);
        if (typeof create_folder.data == "string") {
          setShowRenameModal(true);
          setLoading(false);
          setShowCreateModal(false);
        } else {
          setLoading(false);
          await fetchData(currentPrefix, selectedBucket, awsId);
          setFolderName("");
          setShowCreateModal(false);
        }
      } catch (error) {
        console.error("Error creating folder:", error);
      }
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    formData.append("prefix", currentPrefix);
    formData.append("awsId", awsId);
    formData.append("bucketName", bucketName);

    try {
      setLoading(true);
      let url = await awsService.uploadFileHtml(formData);
      setLoading(false);
      setupLoading(true);
      const response2 = await axios.put(url, file, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          updateProgress(percentCompleted);
        },
      });
      if (response2.status === 200) {
        await fetchData(currentPrefix, selectedBucket, awsId);
        setLoading(false);
        setupLoading(false);
        toast.success("File Uploaded successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log("File uploaded successfully");
        // await fetchData()
      } else {
        console.error("Failed to upload file, status code:", response2.status);
      }

      await fetchData(currentPrefix, selectedBucket, awsId);
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
    }
  };

  const updateProgress = (percentage) => {
    console.log(`Upload Progress: ${percentage}% `);
    if (percentage < 100) {
      setupLoading(true);
    } else {
      setupLoading(false);
    }
  };

  const handleOptionsClick = (e, item) => {
    e.stopPropagation();
    const updatedFiles = files.map((file) =>
      file.Prefix === item.Prefix
        ? { ...file, showOptions: !file.showOptions }
        : file
    );
    setFiles(updatedFiles);
  };
  const handleShare = async (item) => {
    const alreadyExists = await shareService.sharedHtmlList({
      bucketName,
      item,
    });
    setDropdownIndex(null);
    setSharedLink(alreadyExists);
    console.log(item);
    // setShareDetails([])
    setItemToShare(item);

    setShowShareModal(true);
    setDropdownIndex(null); // Close the dropdown
  };

  const handleDownload = async (item) => {
    setLoading(true);
    setDropdownIndex(null);
    console.log(item);
    console.log(`Download: ${item.Key || item.Prefix}`);
    setDropdownIndex(null); // Close the dropdown

    // Form data to send to the server
    const formData = {
      awsId,
      bucketName,
      currentPrefix,
      fileKey: item.Key || item.Prefix,
    };

    try {
      // Fetch the presigned URL for downloading the file
      let url = await awsService.downloadHtmlFile(formData);

      // Download the file using Axios
      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/zip", // Ensure the correct content type
        },
        onDownloadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          // updateProgress(percentCompleted); // Update progress here
        },
      });

      if (response.status === 200) {
        console.log("File downloaded successfully");

        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/zip" })
        );

        // Create a link element to trigger the download
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", item.newName); // Set the file name
        document.body.appendChild(link);
        link.click();
        setLoading(false);
        document.body.removeChild(link);
        setupLoading(false);

        setLoading(false);
      } else {
        setLoading(false);
        setupLoading(false);

        console.error("Failed to download file, status code:", response.status);
        setLoading(false);
      }
    } catch (error) {
      setupLoading(false);

      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  const [shareEmailsList, setShareEmailsList] = useState([]);
  const handleShareSubmit = async (shareDetails) => {
    console.log(shareDetails, itemToShare);
    if (shareDetails.length > 0 && itemToShare) {
      try {
        const response = await shareService.addhtmlshare({
          shareDetails,
          item: itemToShare,
          awsId,
          bucketName,
          userId,
          expiryDate,
          TenantID: selectedTenant._id,
          type: "html",
        });
        console.log(response);
        let url =
          window.location.origin +
          "/gethtmltoken/" +
          response.shareData.token.key;
        console.log(url);
        setShareLink(url);
        // setShareEmailsList(response.credentials);
        setSharePassword(response.shareData.password);
        setShowShareLinkModal(true);
      } catch (error) {
        console.error("Error generating share link:", error);
      }
      setShowShareModal(false);
      setShareEmails([]);
      setExpiryDate(new Date());
    }
  };
  const onSubmit = () => {
    handleShareSubmit(shareDetails);
    setShowShareModal(false);
  };

  const [selectedEmail, setSelectedEmail] = useState("");
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text, copyParam) => {
    // navigator.clipboard.writeText(text);
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text);
      if (copyParam == "link") {
        setCopiedLink(true);
        setTimeout(() => {
          setCopiedLink(false);
        }, 2000);
      }
      if (copyParam == "password") {
        setCopiedPassword(true);
        setTimeout(() => {
          setCopiedPassword(false);
        }, 2000);
      }
    } else {
      // Use the 'out of viewport hidden text area' trick
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Move textarea out of the viewport so it's not visible
      textArea.style.position = "absolute";
      textArea.style.left = "-999999px";

      document.body.prepend(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        if (copyParam == "link") {
          setCopiedLink(true);
          setTimeout(() => {
            setCopiedLink(false);
          }, 2000);
        }
        if (copyParam == "password") {
          setCopiedPassword(true);
          setTimeout(() => {
            setCopiedPassword(false);
          }, 2000);
        }
      } catch (error) {
        console.error(error);
      } finally {
        textArea.remove();
      }
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const [shareDetails, setShareDetails] = useState([
    {
      expiryDate: new Date(),
      uploadAccess: false,
      downloadAccess: true,
      viewOnlyAccess: true,
      withoutPassword: false,
    },
  ]);
  function processPrefix(prefix) {
    if (prefix === "") {
      return null;
    }
    const parts = prefix.split("/").filter(Boolean);
    if (parts.length <= 1) {
      return "";
    }
    parts.pop();
    return parts.join("/") + "/";
  }

  const handleAccessTypeChange = (index, selectedOptions) => {
    console.log(index, selectedOptions);
    const newShareDetails = [...shareDetails];

    newShareDetails[index] = {
      ...newShareDetails[index],
      viewOnlyAccess: false,
      downloadAccess: false,
      uploadAccess: false,
      withoutPassword: false,
    };

    // Set the selected access types to true
    selectedOptions.forEach((option) => {
      newShareDetails[index][option.value] = true;
    });
    console.log(newShareDetails);
    setShareDetails(newShareDetails);
  };

  const handleExpiryDateChange = (index, date) => {
    const newShareDetails = [...shareDetails];
    newShareDetails[index].expiryDate = date;
    setShareDetails(newShareDetails);
  };
  const handlePasswordProtectionChange = (index, isChecked) => {
    const newShareDetails = [...shareDetails];
    console.log(index, isChecked);
    newShareDetails[index].withoutPassword = isChecked;
    console.log(newShareDetails);
    setShareDetails(newShareDetails);
  };
  const handleCheckboxChange = (index, e) => {
    console.log(e.target.checked);
    const newShareDetails = [...shareDetails];
    newShareDetails[index].uploadAccess = e.target.checked;
    setShareDetails(newShareDetails);
  };

  const handleTenantClick = async (index) => {
    SetSelectedTenant(index);

    console.log(index, "indedxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
    const awsAccounts = index.awsAccounts.find((o) => o.isDefault === true);
    setAwsId(awsAccounts.awsId);

    console.log("Selected Tenant:", awsAccounts);
    const filteredBucket = awsAccounts.bucketList.filter((item) =>
      item.bucketName.includes("htmlpackages")
    );
    await handleBucketClick(filteredBucket[0], awsAccounts.awsId);
    // setBuckets(filteredBucket);
    setshowTenant(false);
    setshowBucket(false);
    setshowFiles(true);
    // setCurrentView("bucket");
  };
  const handleBucketClick = async (bucketName, awsIdTenant) => {
    console.log(bucketName);

    // Update selectedBucket first
    setSelectedBucket(bucketName);
    setBucketName(bucketName.bucketName);

    // Call fetchData after selectedBucket is updated
    await fetchData("", bucketName, awsIdTenant).then(async (res) => {
      console.log(res);
      console.log(files, "__________________________files");
      setCreateFolder(true);
      setWriteAccess(false);
      // await fetchData(res[0].Prefix, bucketName, awsIdTenant);
      setshowTenant(false);
      setshowBucket(false);
      setshowFiles(true);
      setCurrentView("folder");
    });
  };

  const handleBackClick = () => {
    setDropdownIndex(null);
    const previous_prefix = processPrefix(currentPrefix);
    console.log(previous_prefix, "--------------------------------");
    if (previous_prefix == "") {
      fetchData("", selectedBucket, awsId);
      setshowTenant(false);
      setshowBucket(false);
      setshowFiles(true);
      setCreateFolder(true);
    } else if (previous_prefix == null) {
      setshowTenant(true);
      setshowBucket(false);
      setshowFiles(false);
      setCurrentView("tenant");
      setCreateFolder(false);
      setWriteAccess(false);
    } else if (currentView === "folder") {
      // Navigate back to the bucket view
      setshowTenant(false);
      setshowBucket(false);
      setshowFiles(true);
      // setCurrentView("bucket");
      setWriteAccess(false);
      // Fetch bucket data again (if needed)
      const previous_prefix = processPrefix(currentPrefix);
      if (previous_prefix != null) {
        fetchData(previous_prefix, selectedBucket, awsId);
      } else {
        setshowFiles(false);
        setshowTenant(true);
        setshowBucket(false);
      }
    } else if (currentView === "bucket") {
      // Navigate back to the tenant view
      setshowTenant(true);
      setshowBucket(false);
      setshowFiles(false);

      setCurrentView("tenant");
      setSelectedBucket(null);
      setCurrentPrefix("");
      setCreateFolder(false);
      setWriteAccess(false);
    } else if (currentView === "file") {
      // Check if there's a parent folder to navigate back to
      if (currentPrefix) {
        // Split the current prefix into parts
        const parts = currentPrefix.split("/");
        // Remove the last two parts to get the parent folder prefix
        const parentPrefix = parts.slice(0, -2).join("/");
        // Fetch data for the parent folder
        fetchData(parentPrefix, selectedBucket, awsId).then(() => {
          setshowTenant(false);
          setshowBucket(false);
          setshowFiles(true);
          setCurrentView("folder");
        });
      } else {
        setshowTenant(true);
        setshowBucket(false);
        setshowFiles(false);
        setCurrentView("tenant");
        setCurrentPrefix("");
        setWriteAccess(false);
        setCreateFolder(false);
        // Fetch bucket data again (if needed)
        // fetchData("", selectedBucket);
      }
    } else {
      console.log(
        "tenante view ###############################################################333"
      );
      // Default case, navigate to tenant view
      setshowTenant(true);
      setshowBucket(false);
      setshowFiles(false);
      setCurrentView("tenant");
      setSelectedBucket(null);
      setCurrentPrefix("");
      setWriteAccess(false);
      setCreateFolder(false);
    }
  };

  const observerCallback = (entries) => {
    for (let entry of entries) {
      if (entry.target === document.documentElement) {
        console.log("Resize detected!");
        // Call your resize handling function here
      }
    }
  };

  // Create a new ResizeObserver
  const resizeObserver = new ResizeObserver(observerCallback);

  // Start observing the document's root element for resize events
  resizeObserver.observe(document.documentElement);

  function countSlashes(inputString) {
    console.log((inputString.match(/\//g) || []).length);
    return (inputString.match(/\//g) || []).length;
  }

  function replaceSpacesWithUnderscores(str) {
    return str.replace(/\s+/g, "_");
  }
  return (
    <>
      {" "}
      <div
        className={`container mx-auto p-4 
    h-auto`}
      >
        {/* <h1 className="text-2xl font-bold mb-4">File Manager</h1> */}
        {/* <hr className="border-t border-gray-500  mt-1" /> */}
        <div className="flex justify-between items-center mb-4">
          <div className="flex space-x-2">
            {!showTenant && (
              <>
                {" "}
                <TooltipComponent content="Back" position="BottomCenter">
                  <button
                    className={`text-gray-500 bg-transparent hover:bg-${
                      currentMode === "Dark" ? "gray-600" : "gray-100"
                    } rounded p-2 z-50`}
                    onClick={handleBackClick}
                  >
                    <FaArrowLeft
                      className="mr-2"
                      style={{
                        fontSize: "1.3rem",
                        color: currentMode === "Dark" ? "#fff" : "",
                      }}
                    />
                  </button>
                </TooltipComponent>
                <TooltipComponent content="Home" position="BottomCenter">
                  <button
                    className={`text-gray-500 bg-transparent hover:bg-${
                      currentMode === "Dark" ? "gray-600" : "gray-100"
                    } rounded p-2 z-50`}
                    onClick={handleHomeClick}
                  >
                    <FaHome
                      className="mr-2"
                      style={{
                        fontSize: "1.5rem",
                        color: currentMode === "Dark" ? "#fff" : "",
                      }}
                    />
                  </button>
                </TooltipComponent>
              </>
            )}
          </div>
          <div className="flex space-x-2">
            <div className="flex space-x-2">
              {currentView === "file" ||
                (currentView === "folder" && (
                  <>
                    <TooltipComponent
                      content="List view"
                      position="BottomCenter"
                    >
                      <button
                        className={`text-gray-500 bg-transparent hover:bg-${
                          currentMode === "Dark" ? "gray-600" : "gray-100"
                        } rounded p-2`}
                        onClick={toggleListView}
                        data-tooltip-id="listView-tooltip"
                      >
                        <FaListUl
                          className="mr-2"
                          style={{
                            fontSize: "1.4rem",
                            color: currentMode === "Dark" ? "#fff" : "",
                          }}
                        />
                      </button>
                    </TooltipComponent>

                    <TooltipComponent
                      content="Grid View"
                      position="BottomCenter"
                    >
                      <button
                        className={`text-gray-500 bg-transparent hover:bg-${
                          currentMode === "Dark" ? "gray-600" : "gray-100"
                        } rounded p-2`}
                        onClick={toggleGridView}
                        data-tooltip-id="gridView-tooltip"
                      >
                        <IoGridOutline
                          className="mr-2"
                          style={{
                            fontSize: "1.4rem",
                            color: currentMode === "Dark" ? "#fff" : "",
                          }}
                        />
                      </button>
                    </TooltipComponent>
                  </>
                ))}
            </div>
            {writeAccess && (
              <>
                <TooltipComponent
                  content=" Upload Zip File"
                  position="BottomCenter"
                >
                  <button
                    className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                    style={{
                      backgroundColor: currentColor,
                      color: currentMode === "Dark" ? "#fff" : "",
                    }}
                    onClick={() => setShowModal(true)}
                    data-tooltip-id="add-tooltip"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </button>
                </TooltipComponent>
              </>
            )}

            {createFolder && !writeAccess && (
              <>
                <button
                  className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                  style={{
                    backgroundColor: currentColor,
                    color: currentMode === "Dark" ? "#fff" : "",
                  }}
                  onClick={() => setShowCreateModal(true)}
                  data-tooltip-id="add-tooltip"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                </button>
                <Tooltip id="add-tooltip" place="top" effect="solid">
                  Create Folder
                </Tooltip>
              </>
            )}
          </div>
        </div>
        {/* <hr className="border-t border-gray-500 " /> */}
        <div>
          {loading && (
            <Loading loading={"loading"} currentColor={currentColor} />
          )}
          {uploading && (
            <Loading loading={"uploading"} currentColor={currentColor} />
          )}

          {viewType === "grid" ? (
            <div>
              {showTenant && !showBucket && !showFiles && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {tenants.map((item) => (
                    <div
                      onClick={() => handleTenantClick(item)}
                      key={item._id}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{ maxWidth: "400px" }}
                    >
                      <FaUsers
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.clientName}
                      >
                        {item.clientName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && showBucket && !showFiles && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {buckets.map((item, index) => (
                    <div
                      onClick={() => {
                        handleBucketClick(item);
                      }}
                      key={index}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{ maxWidth: "400px" }}
                    >
                      <GrStorage
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.bucketName}
                      >
                        {item.bucketName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && !showBucket && showFiles && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {files.map((item, index) => (
                    <div
                      onClick={() =>
                        countSlashes(item.Prefix || item.Key) > 1
                          ? null
                          : handleFolderClick(item.Prefix, selectedBucket)
                      }
                      key={index}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{
                        maxWidth: "400px",
                        cursor:
                          countSlashes(item.Prefix || item.Key) > 1
                            ? "default"
                            : "pointer",
                      }}
                    >
                      {item.Type === "folder" ? (
                        <>
                          <FaFolder
                            size={40}
                            className="mb-3"
                            style={{ color: currentColor }}
                          />
                          <h2
                            className="text-lg font-semibold truncate w-full"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      ) : (
                        <>
                          {["jpg", "png", "avif"].includes(
                            item.Key.split(".").pop().toLowerCase()
                          ) ? (
                            <FaRegFileImage
                              size={40}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          ) : (
                            <CiFileOn
                              size={50}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          )}
                          <h2
                            className="text-sm font-semibold truncate w-full"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      )}
                      {showSharebutton && (
                        <div className="absolute top-0 right-0 mt-2 mr-2">
                          <div className="relative">
                          <button
                              className="text-xl"
                              style={{
                                color: currentMode === "Dark" ? "white" : "gray",
                                width: "29px",
                                borderRadius: "20px",
                                background: "#f3f3f3",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleDropdown(index);
                              }}
                            >
                              &#8942;
                            </button>
                            <div>
                              {dropdownIndex === index && (
                                <div
                                  ref={dropdownRef}
                                  className="absolute right-0 mt-2 bg-white shadow-lg rounded-lg z-10"
                                >
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={() => handleShare(item)}
                                    style={{ width: "100%" }}
                                  >
                                    Share
                                  </button>
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={() => handleDownload(item)}
                                  >
                                    Download
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div>
              {showTenant && !showBucket && !showFiles && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                  {tenants.map((item) => (
                    <div
                      onClick={() => handleTenantClick(item)}
                      key={item._id}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{ maxWidth: "400px" }}
                    >
                      <FaUsers
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.clientName}
                      >
                        {item.clientName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && showBucket && !showFiles && (
                <div className="">
                  {buckets.map((item, index) => (
                    <div
                      onClick={() => {
                        handleBucketClick(item);
                      }}
                      key={index}
                      className={`p-4 rounded-lg shadow-md cursor-pointer relative ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white  border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{ maxWidth: "400px" }}
                    >
                      <GrStorage
                        size={40}
                        className="mb-3"
                        style={{ color: currentColor }}
                      />
                      <h2
                        className="text-lg font-bold truncate w-full"
                        title={item.bucketName}
                      >
                        {item.bucketName}
                      </h2>
                    </div>
                  ))}
                </div>
              )}

              {!showTenant && !showBucket && showFiles && (
                <div className="">
                  {files.map((item, index) => (
                    <div
                      onClick={() =>
                        countSlashes(item.Prefix || item.Key) > 1
                          ? null
                          : handleFolderClick(item.Prefix, selectedBucket)
                      }
                      key={index}
                      className={`flex items-center shadow-md cursor-pointer bg-white p-2 shadow-md cursor-pointer relative mt-2 rounded-md ${
                        currentMode === "Dark"
                          ? "text-white bg-[#33373E]"
                          : "bg-white border-t-4 border-b-4 border-l border-r border-gray-300"
                      }`}
                      style={{
                        cursor:
                          countSlashes(item.Prefix || item.Key) > 1
                            ? "default"
                            : "pointer",
                      }}
                    >
                      {item.Type === "folder" ? (
                        <>
                          <FaFolder
                            size={30}
                            className="mb-3"
                            style={{ color: currentColor }}
                          />
                          <h2
                            className="text-lg font-semibold truncate w-full"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      ) : (
                        <>
                          {["jpg", "png", "avif"].includes(
                            item.Key.split(".").pop().toLowerCase()
                          ) ? (
                            <FaRegFileImage
                              size={40}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          ) : (
                            <CiFileOn
                              size={50}
                              className="mb-3"
                              style={{ color: currentColor }}
                              onClick={() => handleFileClick(item.Key)}
                            />
                          )}
                          <h2
                            className="text-sm font-semibold truncate w-full"
                            title={item.newName}
                          >
                            {item.newName}
                          </h2>
                        </>
                      )}

                      {showSharebutton && (
                        <div className="ml-auto flex items-center">
                          {/* <TooltipComponent
                            content="share"
                            position="BottomCenter"
                          > */}
                          <span
                            className="ml-3"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleShare(item);
                            }}
                            style={{ cursor: "pointer", paddingRight: "10%" }}
                          >
                            <IoMdShareAlt
                              size={25}
                              color="gray"
                              style={{
                                color: currentMode === "Dark" ? "#fff" : "",
                              }}
                            />
                          </span>
                          {/* </TooltipComponent>
                          <TooltipComponent */}
                          {/* content="download"
                            position="BottomCenter"
                          > */}
                          <span
                            className="mr-4"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDownload(item);
                            }}
                            style={{ cursor: "pointer", paddingRight: "10%" }}
                          >
                            <MdDownload
                              size={25}
                              color="gray"
                              style={{
                                color: currentMode === "Dark" ? "#fff" : "",
                              }}
                            />
                          </span>
                          {/* </TooltipComponent> */}
                          {/* <span
                          onClick={() => handleDownload(item)}
                         style={{ cursor: "pointer" }}
                       >
                         <MdDownload
                           size={25}
                           color="gray"
                           style={{
                             color: currentMode === "Dark" ? "#fff" : "",
                           }}
                         />
                       </span> */}
                        </div>
                      )}
                      {/* {showSharebutton && (
                        <div className="absolute top-0 right-0 mt-2 mr-2">
                          <div className="relative">
                            <button
                              className="text-xl"
                              style={{
                                color:
                                  currentMode === "Dark" ? "#FFFFFF" : "gray",
                              }}
                              onClick={() => toggleDropdown(index)}
                            >
                              &#8942;
                            </button>
                            <div>
                              {dropdownIndex === index && (
                                <div
                                  ref={dropdownRef}
                                  className="absolute right-0 mt-2 bg-white shadow-lg rounded-lg z-10"
                                >
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={() => handleShare(item)}
                                    style={{ width: "100%" }}
                                  >
                                    Share
                                  </button>
                                  <button
                                    className="block px-4 py-2 text-gray-800 hover:bg-gray-200"
                                    onClick={() => handleDownload(item)}
                                  >
                                    Download
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )} */}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 relative">
                <button
                  className="absolute top-0 right-0 p-2 text-gray-500 bg- hover:text-gray-700"
                  onClick={() => setShowModal(false)}
                >
                  <FaTimes />
                </button>
                <div className="flex justify-around">
                  <label className=" px-4 py-2 rounded cursor-pointer">
                    <AiFillFileZip
                      size={50}
                      className="mb-3 "
                      style={{ color: currentColor }}
                    />
                    Upload HTML package
                    <input
                      type="file"
                      className="hidden"
                      accept=".zip"
                      onChange={(e) => {
                        handleFileUpload(e);
                        setShowModal(false);
                      }}
                    />
                  </label>
                </div>
              </div>
            </div>
          )}

          {createModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-lg p-6 relative">
                <button
                  className="absolute top-0 right-0 p-2 text-gray-500 hover:text-gray-700"
                  onClick={() => {
                    setFolderName("");
                    setLoading(false);
                    setShowCreateModal(false);
                  }}
                >
                  <FaTimes />
                </button>
                <div className="flex flex-col items-center">
                  <div>
                    <FaFolder
                      size={20}
                      className="mb-3"
                      style={{ color: currentColor }}
                    />
                    <input
                      type="text"
                      className="border border-gray-300 rounded px-4 py-2 mb-4 w-full"
                      placeholder="Enter folder name"
                      value={folderName}
                      onChange={(e) => setFolderName(e.target.value)}
                    />
                  </div>
                  <button
                    className="px-4 py-2 rounded bg-blue-500 text-white hover:bg-blue-700"
                    onClick={handleCreateFolder}
                  >
                    Create Folder
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <Modal
          show={showShareModal}
          size="lg"
          onHide={() => setShowShareModal(false)}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-90h"
          className="modal-dialog-centered modal-90h"
        >
          <Modal.Header className="bg-white border-b border-gray-300">
            <div className="text-xl font-semibold text-gray-600">Share</div>
            <Button
              variant="light"
              onClick={() => setShowShareModal(false)}
              className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
              // data-tooltip-id="close-tooltip"
            >
              <FaTimes color="gray" />
            </Button>
            {/* <Tooltip id="close-tooltip" place="top" effect="solid">
              Close
            </Tooltip> */}
          </Modal.Header>
          <Modal.Body className="p-6 overflow-auto max-h-96">
            {/* <Form>
              {shareDetails.map((shareDetail, index) => (
                <div key={index} className="mb-6">
                  <Form.Group controlId={`formExpiryDate${index}`}>
                    <div className="flex items-center justify-between space-x-4">
                      <div className="flex flex-col">
                        <label className="block text-base font-medium text-gray-700 mb-2">
                          Expiry Date
                        </label>
                        <div className="flex items-center border border-gray-300 rounded-lg p-2 flex-grow">
                          <FaCalendarAlt className="text-gray-500 mx-2" />
                          <DatePicker
                            minDate={subDays(new Date(), 0)}
                            selected={shareDetail.expiryDate}
                            onChange={(date) =>
                              handleExpiryDateChange(index, date)
                            }
                            dateFormat="P" // Use "P" to format the date without time
                            placeholderText="Select expiry date"
                            className="w-full px-2 py-0.5 rounded-lg outline-none"
                            style={{ border: "none" }}
                          />
                        </div>
                      </div>
                      <div className="flex-grow">
                        <div className="flex flex-col">
                          <label className="block text-base font-medium text-gray-700 mb-2">
                            Access level
                          </label>

                          <Select
                            key={index}
                            options={options}
                            isMulti
                            placeholder="Select access type"
                            classNamePrefix="react-select"
                            value={options.filter(
                              (option) => shareDetail[option.value] === true
                            )}
                            onChange={(selected) =>
                              handleAccessTypeChange(index, selected)
                            }
                            styles={customStyles}
                          />
                        </div>
                      </div>
                      <Button
                        className="ml-4  mt-4 flex items-center justify-center px-4 py-2 text-white rounded-full hover:bg-opacity-90"
                        style={{
                          backgroundColor: currentColor,
                          border: "none",
                        }}
                        onClick={onSubmit}
                      >
                        Share
                      </Button>
                    </div>
                  
                  </Form.Group>
                </div>
              ))}
            </Form> */}

            <Form>
              {shareDetails.map((shareDetail, index) => (
                <div key={index} className="mb-6">
                  <Form.Group controlId={`formExpiryDate${index}`}>
                    <div className="flex items-center justify-between space-x-4">
                      <div className="flex flex-col">
                        <label className="block text-base font-medium text-gray-700 mb-2">
                          Expiry Date
                        </label>
                        <div className="flex items-center border border-gray-300 rounded-lg p-2 flex-grow">
                          <FaCalendarAlt className="text-gray-500 mx-2" />
                          <DatePicker
                            minDate={subDays(new Date(), 0)}
                            selected={shareDetail.expiryDate}
                            onChange={(date) =>
                              handleExpiryDateChange(index, date)
                            }
                            dateFormat="P" // Use "P" to format the date without time
                            placeholderText="Select expiry date"
                            className="w-full px-2 py-0.5 rounded-lg outline-none"
                            style={{ border: "none" }}
                          />
                        </div>
                      </div>
                      <div className="flex-grow">
                        <div className="flex flex-col">
                          <label className="block text-base font-medium text-gray-700 mb-2">
                            Access level
                          </label>

                          <Select
                            key={index}
                            options={options}
                            isMulti
                            placeholder="Select access type"
                            classNamePrefix="react-select"
                            value={options.filter(
                              (option) => shareDetail[option.value] === true
                            )}
                            onChange={(selected) =>
                              handleAccessTypeChange(index, selected)
                            }
                            styles={customStyles}
                          />
                        </div>
                      </div>
                      <Button
                        className="ml-4 mt-4 flex items-center justify-center px-4 py-2 text-white rounded-full hover:bg-opacity-90"
                        style={{
                          backgroundColor: currentColor,
                          border: "none",
                        }}
                        onClick={onSubmit}
                      >
                        Share
                      </Button>
                    </div>

                    <div className="mt-3">
                      <Form.Check
                        type="checkbox"
                        id={`passwordProtection${index}`}
                        label="Protect with password"
                        checked={!shareDetail.withoutPassword}
                        onChange={(e) =>
                          handlePasswordProtectionChange(
                            index,
                            !e.target.checked
                          )
                        }
                        className="mb-2"
                      />
                    </div>
                  </Form.Group>
                </div>
              ))}
            </Form>
            <SharedLinks sharedLink={sharedLink} keys="gethtmltoken" />
          </Modal.Body>
          <Modal.Footer
            className="flex justify-end "
            style={{ borderTop: "none" }}
          ></Modal.Footer>
        </Modal>

        <Modal
          show={showShareLinkModal}
          onHide={() => setShowShareLinkModal(false)}
          backdrop="static"
          keyboard={false}
          className="modal-dialog-centered"
        >
          <Modal.Header className="bg-white border-b border-gray-300">
            <div className="text-xl font-semibold text-gray-600">Share</div>
            <Button
              variant="light"
              onClick={() => setShowShareLinkModal(false)}
              className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
              // data-tooltip-id="close-tooltip"
            >
              <FaTimes color="gray" />
            </Button>
          </Modal.Header>
          <Modal.Body className="p-6 overflow-auto">
            <Form>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1 },
                }}
                noValidate
                autoComplete="off"
              >
                <div className="flex mb-3">
                  <div className="flex-1 mr-2">
                    <TextField
                      label="Share Link"
                      value={shareLink}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => copyToClipboard(shareLink, "link")}
                            >
                              {copiedLink ? (
                                <FaCheck
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              ) : (
                                <FaCopy
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </div>
                 {sharePassword && <div className="flex-shrink-0 w-1/3">
                    <TextField
                      label="Password"
                      value={sharePassword}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                copyToClipboard(sharePassword, "password")
                              }
                            >
                              {copiedPassword ? (
                                <FaCheck
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              ) : (
                                <FaCopy
                                  size={18}
                                  style={{ color: currentColor }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </div>}
                </div>
              </Box>
            </Form>
          </Modal.Body>
          <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
            <button></button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={renameModal}
          onHide={() => setShowRenameModal(false)}
          backdrop="static"
          keyboard={false}
          className="modal-dialog-centered"
        >
          <Modal.Header className="bg-white border-b border-gray-300">
            {/* <div class="p-3 mb-2 bg-warning text-dark">File name already exists. Copy or Replace</div> */}
            <div className="text-xl font-semibold text-gray-600">
              Folder already Exits. Please enter new name
            </div>
            <Button
              variant="light"
              onClick={() => setShowRenameModal(false)}
              className="ml-auto bg-transparent text-gray-700 hover:text-gray-900 p-2 rounded-full"
            >
              <FaTimes color="gray" />
            </Button>
          </Modal.Header>
          <Modal.Body className="p-6 overflow-auto">
            <Form>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1 },
                }}
                noValidate
                autoComplete="off"
              >
                <div className="flex mb-3">
                  <div className="flex-1 mr-2">
                    <input
                      type="text"
                      placeholder="Filename"
                      value={folderName}
                      onChange={(e) => setFolderName(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>
                {/* <div className="flex mb-3">
          <div className="flex-1 mr-2">
            <TextField
              label="Filename"
              value={fileContent.name}
              InputProps={{
                readOnly: false,
              }}
              variant="outlined"
              size="small"
              fullWidth
            />
          </div>
        </div> */}
              </Box>
            </Form>
          </Modal.Body>
          <Modal.Footer className="bg-gray-200 border-t border-gray-300 flex justify-end">
            <Button
              variant="primary"
              onClick={() => {
                // Implement the copy functionality here
                console.log("Copy clicked");
                setShowRenameModal(false);
                handleRenameFolder();
              }}
              className="mr-2"
            >
              rename
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <ToastContainer />
    </>
  );
};

export default HtmlPackage;
